const addTrailingSlash = uri => {
  if (!uri) {
    return '/'
  }
  return uri.trim()[uri.trim().length - 1] === '/' ? uri : `${uri}/`
}

export default addTrailingSlash
